var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { WordTask } from '../../KnowAWord/WordTask/WordTask';
import { deserialize } from '../../../utils/serializr/serializr';
import { MemorizePointsWordTaskEdit } from './MemorizePointsWordTaskEdit';
import { MemorizePointsWordTaskInput } from './MemorizePointsWordTaskInput';
import { MemorizePointsWordTaskEvaluator } from './MemorizePointsWordTaskEvaluator';
import { MemorizePointsWordTaskActions } from './MemorizePointsWordTaskActions';
import { MemorizePointsWordTaskMutability } from './MemorizePointsWordTaskMutability';
export class MemorizePointsWordTask extends WordTask {
    get question() {
        return this.parent;
    }
    get wordTaskIndex() {
        return this.question.wordTasks.indexOf(this);
    }
    get wordTaskNumber() {
        return this.wordTaskIndex + 1;
    }
    get itemNumber() {
        return this.question.memorizePointsForUI.wordTasksToDisplay.indexOf(this) + 1;
    }
    get isActiveWordTask() {
        return this.question.memorizePointsRemaining.activeWordTask === this;
    }
    get wordTaskEdit() {
        return new MemorizePointsWordTaskEdit(this);
    }
    get wordTaskInput() {
        return new MemorizePointsWordTaskInput(this);
    }
    get wordTaskEvaluate() {
        return new MemorizePointsWordTaskEvaluator(this);
    }
    get wordTaskActions() {
        return new MemorizePointsWordTaskActions(this);
    }
    mutability = new MemorizePointsWordTaskMutability(this);
    static fromSerialized(json = {}) {
        return deserialize(MemorizePointsWordTask, json);
    }
    static get serializeInfo() {
        return {
            extends: WordTask.serializeInfo,
            props: {},
        };
    }
}
__decorate([
    memoize
], MemorizePointsWordTask.prototype, "wordTaskEdit", null);
__decorate([
    memoize
], MemorizePointsWordTask.prototype, "wordTaskInput", null);
__decorate([
    memoize
], MemorizePointsWordTask.prototype, "wordTaskEvaluate", null);
__decorate([
    memoize
], MemorizePointsWordTask.prototype, "wordTaskActions", null);
__decorate([
    memoize
], MemorizePointsWordTask, "serializeInfo", null);
